import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import styles from "./examiner.module.css";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import * as actions from '../../store/actions/index'

const Examiner = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  let emptyExaminer = {
    userid:'',
    email: "",
    name: "",
    phone: "",
    bank: "",
    branch: "",
    ifsccode: "",
    accno: "",
    panno: "",
  };

  const [examiner, setExaminer] = useState(emptyExaminer);
  const [examiners, setExaminers] = useState([]);
  const [selectedExaminers, setSelectedExaminers] = useState(null);
  const [examinerDialog, setExaminerDialog] = useState(false);
  const [resetDialog, setResetDialog] = useState(false);
  const [deleteExaminerDialog, setDeleteExaminerDialog] = useState(false);

  const [mode, setMode] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    let authOptions = {
      method: "GET",
      url: "/examiner/Coord/"+props.userid,
      data: { 'userid': props.userid },
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setExaminers(response.data);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
        setExaminers([]);
      });
  }, [props.userid]); 

  const openNew = () => {
    setExaminer(emptyExaminer);
    setSubmitted(false);
    setMode("New");
    setExaminerDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setExaminerDialog(false);
  };

  const hideDeleteExaminerDialog = () => {
    setDeleteExaminerDialog(false);
  };

  const hideResetDialog = () => {
    setResetDialog(false);
  };

  const saveExaminer = () => {
    setSubmitted(true);

    if (examiner.name.trim()) {
      let _examiners = [...examiners];
      let _examiner = { ...examiner };
      _examiner.userid = props.userid;
      if (mode === "Edit") {
        const index = findIndexById(examiner._id);
        _examiners[index] = _examiner;
        let authOptions = {
          method: "PUT",
          url: "/examiner/",
          data: _examiner,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Examiner Edited",
              life: 3000,
            });
            setExaminers(_examiners);
            setExaminerDialog(false);
            setExaminer(emptyExaminer);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      } else {
        _examiner.userid = props.userid;
        let authOptions = {
          method: "POST",
          url: "/examiner/",
          data: _examiner,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Examiner Created",
              life: 3000,
            });
            _examiners.push(response.data);
            setExaminers(_examiners);
            setExaminerDialog(false);
            setExaminer(emptyExaminer);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      }
    }
  };

  const editExaminer = (examiner) => {
    setExaminer({ ...examiner });
    setMode("Edit");
    setExaminerDialog(true);
  };

  const confirmDeleteExaminer = (examiner) => {
    setExaminer(examiner);
    setDeleteExaminerDialog(true);
  };

  const confirmReset = (examiner) => {
    setExaminer(examiner);
    setResetDialog(true);
  };

  const resetPassword = () => {
    let authOptions = {
      method: "PUT",
      url: "/examiner/resetpwd",
      data: examiner,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setResetDialog(false);
        setExaminer(emptyExaminer);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Password Reset Successfully",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };

  const deleteExaminer = () => {
    let authOptions = {
      method: "put",
      url: "/examiner/deactivate",
      data: examiner,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
          let _examiners = examiners.filter(val => val.email !== examiner.email);
          setExaminers(_examiners);
        setDeleteExaminerDialog(false);
        setExaminer(emptyExaminer);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Examiner Deactivated",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < examiners.length; i++) {
      if (examiners[i]._id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _examiner = { ...examiner };
    _examiner[`${name}`] = val;
    setExaminer(_examiner);
  };
  
  // const onInputChangeboolean = (e, name) => {
  //     const val = e.value;
  //     let _examiner = {...examiner};
  //     _examiner[`${name}`] = val;
  //     setExaminer(_examiner);
  // }

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={openNew}
        />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
      </React.Fragment>
    );
  };

  // const isAdminBodyTemplate = (rowData) => {
  //     return (rowData.isAdmin?<span >True</span>:<span >False</span> );
  // }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => editExaminer(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => confirmDeleteExaminer(rowData)}
        />
        <Button
          label="Reset Pwd"
          className="p-button-rounded p-button-text "
          onClick={() => confirmReset(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <h4 className="mx-0 my-1">Manage Examiners</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const examinerDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text"
        onClick={saveExaminer}
      />
    </React.Fragment>
  );
  const deleteExaminerDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteExaminerDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteExaminer}
      />
    </React.Fragment>
  );

  const resetDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideResetDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={resetPassword}
      />
    </React.Fragment>
  );

  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Coord ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Regional Centre Module
          <br />
          Practicals Examiner Management
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <div className={styles.card}>
        <Toolbar
          className="p-mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={examiners}
          selection={selectedExaminers}
          onSelectionChange={(e) => setSelectedExaminers(e.value)}
          dataKey="email"
          sortField="email"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} examiners"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="email"
            header="Email ID"
            sortable
            style={{ width: "13%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="name"
            header="Name"
            sortable
            style={{ width: "18%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column field="phone" header="Phone" style={{ width: "8%" , padding:'0 1px 0 1px' }}></Column>
          <Column
            field="bank"
            header="Bank"
            sortable
            style={{ width: "10%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="ifsccode"
            header="IFSC Code"
            style={{ width: "10%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="accno"
            header="Acc. No"
            style={{ width: "10%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="panno"
            header="PAN No"
            style={{ width: "8%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column
            field="status"
            header="Status"
            sortable
            style={{ width: "6%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{  padding:'0 1px 0 1px'}}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={examinerDialog}
        style={{ width: "450px" }}
        header="Examiner Details"
        modal
        className="p-fluid"
        footer={examinerDialogFooter}
        onHide={hideDialog}
      >
        <div className="p-field">
          <label htmlFor="email">Email ID*</label>
          <InputText
            htmlFor="emailid"
            keyfilter="email"
            pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
            value={examiner.email}
            onChange={(e) => onInputChange(e, "email")}
            required
            className={classNames({
              "p-invalid": submitted && !examiner.email,
            })}
          />
          {submitted && !examiner.email && (
            <small className="p-error">Email Id is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="name">Examiner Name*</label>
          <InputText
            id="name"
            value={examiner.name}
            onChange={(e) => onInputChange(e, "name")}
            required
            className={classNames({ "p-invalid": submitted && !examiner.name })}
          />
          {submitted && !examiner.name && (
            <small className="p-error">Name is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="phone">Contact No*</label>
          <InputText
            id="phone"
            value={examiner.phone}
            onChange={(e) => onInputChange(e, "phone")}
            required
            className={classNames({
              "p-invalid": submitted && !examiner.phone,
            })}
          />
          {submitted && !examiner.phone && (
            <small className="p-error">Pnone is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="phone]">Bank Name*</label>
          <InputText
            id="bank"
            value={examiner.bank}
            onChange={(e) => onInputChange(e, "bank")}
          />
        </div>
        <div className="p-field">
          <label htmlFor="name">Branch Name*</label>
          <InputText
            id="name"
            value={examiner.branch}
            onChange={(e) => onInputChange(e, "branch")}
          />
        </div>
        <div className="p-field">
          <label htmlFor="ifsccode">IFSC Code*</label>
          <InputText
            id="ifsccode"
            value={examiner.ifsccode}
            onChange={(e) => onInputChange(e, "ifsccode")}
          />
        </div>
        <div className="p-field">
          <label htmlFor="accno">Account No*</label>
          <InputText
            id="accno"
            value={examiner.accno}
            onChange={(e) => onInputChange(e, "accno")}
          />
        </div>
        <div className="p-field">
          <label htmlFor="name">PAN No*</label>
          <InputText
            id="panno"
            value={examiner.panno}
            onChange={(e) => onInputChange(e, "panno")}
          />
        </div>
      </Dialog>

      <Dialog
        visible={deleteExaminerDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deleteExaminerDialogFooter}
        onHide={hideDeleteExaminerDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {examiner && (
            <span>
              Are you sure you want to Deactivate <b>{examiner.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={resetDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={resetDialogFooter}
        onHide={hideResetDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {examiner && (
            <span>
              Are you sure you Reset Password of <b>{examiner.email}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Examiner);